"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Throbber = () => {
  const theme = (0, _styles.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "bounce-loader",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cssload-float-rings-loader",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "cssload-float-rings-inner cssload-one"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "cssload-float-rings-inner cssload-two"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "cssload-float-rings-inner cssload-three"
      })]
    })
  });
};
var _default = exports.default = Throbber;